export { default } from './app-bar-view.js';